import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/pages/Home/routes'
import Auth from '@/views/pages/Auth/routes'
import TicketsRoutes from '@/views/pages/Tickets/routes'
import TestsRoutes from '@/views/pages/Tests/routes'
import SettingsRoutes from '@/views/pages/Settings/routes'
import ApplicationsRoutes from '@/views/pages/Applications/routes'
import UsersRoutes from '@/views/pages/Users/routes'
import GroupsRoutes from '@/views/pages/Groups/routes'
import OrganizationsStatsRoutes from '@/views/pages/OrganizationsStats/routes'
import KnowledgesRoutes from '@/views/pages/Knowledges/routes'
import EducationPlanRoutes from '@/views/pages/EducationPlan/routes'
import ShareRoutes from '@/views/pages/Share/routes'
import defaultRoutes from '@/views/pages/routes'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [


        ...TicketsRoutes,
        ...SettingsRoutes,
        ...ApplicationsRoutes,
        ...UsersRoutes,
        ...GroupsRoutes,
        ...KnowledgesRoutes,
        ...EducationPlanRoutes,
        ...OrganizationsStatsRoutes,
        ...ShareRoutes,
        ...TestsRoutes,
        ...Home,
        ...Auth,
        //put here your routes
        ...defaultRoutes
    ],
});

import store from '@/store'
import {get} from "lodash";

router.beforeEach((to, from, next) => {
    if (get(to, 'meta.guestRoute', false) === false && to.name !== 'auth.login' && to.name !== 'auth.oauth' && !store.getters['e/users/isLoggedIn']) next({ name: 'auth.login' })
    else next()

   // next()
})


export default router;
